import React, { useState, Dispatch, SetStateAction, useEffect } from "react";
import dayjs from "dayjs";
import styled from "styled-components";
import ConfirmBtn from "../../../../Button/ConfirmBtn";
import Flex from "../../../../DefaultStyles/Flex";
import AlertModal from "../../../../Modal/AlertModal";
import { useSetRecoilState } from "recoil";
import { faqInputState } from "../../../../../pages/Manage/ManageFaq/ManageFaqDetail";
import { OptionType } from "../../../../Filters/DropDown";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useApi } from "../../../../../hooks/useApi";
import { toast } from "react-toastify";
import Loader from "../../../../DefaultStyles/Loader";
import FaqDeleteModal from "./ManageFaqDetailFooter/FaqDeleteModal";
import { commonString } from "../../../../../AdminApi/commFunc";
import moment from "moment";
import subscription_set from "../../../../../data_json/subscription_set.json";

interface ManageFaqDetailFooterProps {
  category: OptionType;
  tag: string;
  search: OptionType[] | null;
  check: {
    public: boolean;
    private: boolean;
    top: boolean;
    normal: boolean;
    noService: boolean;
  };
  memo: string;
  title: string;
  contents: string;
  keyword: number[];
  editMode: boolean;
  setEditMode: Dispatch<SetStateAction<boolean>>;
  admin: string;
  updateDate: string;
  initkeyword: number[];
  subsId: number[];
  publicRange: {
    faq: boolean;
    myparty: boolean;
  };
  party: {
    state: {
      all: boolean;
      before: boolean;
      start: boolean;
      end: boolean;
    };
    role: {
      all: boolean;
      owner: boolean;
      member: boolean;
    };
  };
  initSubsList: number[];
}

export default function ManageFaqDetailFooter({
  category,
  tag,
  search,
  check,
  memo,
  title,
  contents,
  keyword,
  editMode,
  setEditMode,
  admin,
  initkeyword,
  updateDate,
  subsId,
  publicRange,
  party,
  initSubsList,
}: ManageFaqDetailFooterProps) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { faqId, noticeId, termsId } = useParams();

  const isFaq = Boolean(pathname.includes("faq"));
  const isNotice = Boolean(pathname.includes("notice"));
  const isAddFaq = Boolean(pathname.includes("add"));

  const paramsId = isFaq ? faqId : isNotice ? noticeId : termsId;

  const [checkIsTop, setCheckIsTop] = useState(false); // 상단 고정 게시물이 있는지 체크
  const [isTopAlert, setIsTopAlert] = useState(false);
  const [add, setAdd] = useState(false); // 추가
  const [askEditModal, setAskEditModal] = useState(false);
  const [edit, setEdit] = useState(false); // 수정
  const [deleteModal, setDeleteModal] = useState(false); // 삭제 모달

  const setSavedContent = useSetRecoilState(faqInputState);

  console.log(subsId);
  const activatedSubscription = subscription_set.filter(
    (data) =>
      moment().isSameOrAfter(
        moment(data.SUBS_ADATE).format("YYYY-MM-DD HH:mm")
      ) && data?.SUBS_ACT === "activate"
  );

  const isAllSubsId = subsId?.length === activatedSubscription?.length;

  console.log(
    initSubsList,
    subsId?.every((s, i) => s === initSubsList[i]),
    subsId?.length > 0
  );

  // 상단 고정 게시물 체크
  const {
    response: chkRes,
    loading: chkLoading,
    error: chkError,
  } = useApi({
    method: "get",
    url: checkIsTop ? `notice/istop` : undefined,
  });

  // 추가
  const {
    response: addResponse,
    loading: addLoading,
    error: addError,
  } = useApi({
    method: "post",
    url: add ? (isFaq ? `FAQ` : `notice`) : undefined,
    data: isFaq
      ? {
          category: category?.value,
          title,
          tag,
          content: contents,
          status:
            (party?.state?.before ? 1 : 0) |
            (party?.state?.start ? 2 : 0) |
            (party?.state?.end ? 4 : 0),
          partygrade: party?.role?.owner ? 0 : party?.role?.member ? 1 : 2,
          desc: memo,
          ispublic: check?.private
            ? 0
            : publicRange?.myparty && publicRange?.faq
            ? 3
            : publicRange?.myparty
            ? 2
            : publicRange?.faq
            ? 1
            : check?.public
            ? 3
            : 0,
          isKeyChanged: 1,
          keyword,
          isServiceChanged: subsId?.length > 0 ? 1 : 0,
          servsubsid: isAllSubsId ? [0] : subsId ?? [],
        }
      : {
          isNotice: isNotice ? 1 : 0,
          categoryId: Number(category?.value) ?? 0,
          ispublic: check?.public ? 1 : 0,
          isTop: check?.top ? 1 : 0,
          title,
          content: contents,
          desc: memo,
        },
  });

  // 수정
  const {
    response: editResponse,
    loading: editLoading,
    error: editError,
  } = useApi({
    method: "post",
    url: edit ? `${isFaq ? `FAQ` : `notice`}/${paramsId}` : undefined,
    data: isFaq
      ? {
          category: category?.value,
          title,
          tag,
          content: contents,
          status:
            (party?.state?.before ? 1 : 0) |
            (party?.state?.start ? 2 : 0) |
            (party?.state?.end ? 4 : 0),
          partygrade: party?.role?.owner ? 0 : party?.role?.member ? 1 : 2,
          desc: memo,
          ispublic: check?.private
            ? 0
            : publicRange?.myparty && publicRange?.faq
            ? 3
            : publicRange?.myparty
            ? 2
            : publicRange?.faq
            ? 1
            : check?.public
            ? 3
            : 0,
          isKeyChanged: initkeyword.join("") === keyword.join("") ? 0 : 1,
          keyword,
          isServiceChanged:
            subsId?.every((s, i) => s === initSubsList[i]) || subsId?.length > 0
              ? 1
              : 0,
          servsubsid: isAllSubsId ? [0] : subsId ?? [],
        }
      : {
          isNotice: isNotice ? 1 : 0,
          categoryId: Number(category?.value) ?? 0,
          ispublic: check?.public ? 1 : 0,
          isTop: check?.top ? 1 : 0,
          title,
          content: contents,
          desc: memo,
        },
  });

  useEffect(() => {
    if (chkRes?.status === 200) {
      if (isAddFaq) {
        // 추가 과정
        if (chkRes?.data?.id !== 0) {
          setIsTopAlert(true);
        } else {
          setAdd(true);
        }
      } else {
        if (chkRes?.data?.id !== Number(paramsId ?? 0)) {
          setIsTopAlert(true);
        } else {
          setAskEditModal(true);
        }
      }
    }
  }, [chkRes]);

  console.log(addResponse);
  console.log(editResponse);

  useEffect(() => {
    if (addResponse?.status === 200 || editResponse?.status === 200) {
      toast.success(
        `${commonString(pathname).title}이 ${
          editResponse?.status === 200 ? "수정" : "추가"
        }되었습니다.`
      );
      navigate(
        `/linkid-manage/${commonString(pathname).route}/${
          addResponse?.data?.id ?? paramsId ?? 0
        }`
      );
      setAdd(false);
      setEdit(false);
    }
  }, [addResponse, editResponse]);

  useEffect(() => {
    if (chkError) {
      toast.error(
        chkError?.data ?? "상단 고정 게시물을 확인하는 데에 실패하였습니다."
      );
    }
  }, [chkError]);

  useEffect(() => {
    if (addError || editError) {
      toast.error(
        addError?.data ??
          editError?.data ??
          `${commonString(pathname).title} ${
            edit ? "수정" : "추가"
          }에 실패하였습니다.`
      );

      setAdd(false);
      setEdit(false);
    }
  }, [addError, editError]);

  console.log(
    category.label === "서비스 이용" && subsId?.length === 0,
    category?.value === "",
    !Object.values(check)?.includes(true),
    isFaq ? search?.length === 0 : false,
    title === "",
    contents === ""
  );

  return (
    <FaqDetailFooterContainer>
      <Manager>
        {dayjs(updateDate ?? undefined).format("YYYY.MM.DD (dd)")}
        <br />
        관리자: {admin}
      </Manager>

      {isAddFaq ? (
        <ConfirmBtn
          btnText="작성 완료"
          btnColor="mint"
          btnClickEvent={() => {
            if (isNotice && check?.top) {
              setCheckIsTop(true);
            } else {
              setAdd(true);
            }
          }}
          isDisabled={
            category?.value === "" ||
            (isNotice
              ? Object.values(check)?.filter((a) => a === true)?.length !== 2
              : !Object.values(check)?.includes(true)) ||
            // (isFaq ? search?.length === 0 : false) ||
            title === "" ||
            contents === ""
          }
        />
      ) : editMode ? (
        <Flex gapSize={10}>
          <ConfirmBtn
            btnText="취소"
            btnClickEvent={() => setEditMode(false)}
            btnTextColor="#2f2f38"
          />

          <ConfirmBtn
            btnText="수정 완료"
            btnColor="mint"
            isDisabled={
              (category.label === "서비스 이용" && subsId?.length === 0) ||
              category?.value === "" ||
              !Object.values(check)?.includes(true) ||
              // (isFaq ? search?.length === 0 : false) ||
              title === "" ||
              contents === ""
            }
            btnClickEvent={() => {
              if (isNotice && check?.top) {
                setCheckIsTop(true);
              } else {
                setAskEditModal(true);
              }
            }}
          />
        </Flex>
      ) : (
        <Flex gapSize={10}>
          <ConfirmBtn
            btnText="삭제"
            btnColor="white"
            btnTextColor="#f42d16"
            btnClickEvent={() => {
              setDeleteModal(true);
            }}
          />

          <ConfirmBtn
            btnText="수정"
            btnColor="mint"
            btnClickEvent={() => {
              setEditMode(true);
            }}
          />
        </Flex>
      )}

      {(addLoading || editLoading || chkLoading) && <Loader />}

      {/* 자주 묻는 질문 삭제 모달 */}
      {deleteModal && (
        <FaqDeleteModal closeEvent={() => setDeleteModal(false)} />
      )}

      {askEditModal && (
        <AlertModal
          title={`해당 ${commonString(pathname).title}이 수정됩니다.
  계속 하시겠습니까?`}
          btnColor="mint"
          confirmEvent={() => {
            setAskEditModal(false);
            setEdit(true);
            setEditMode(false);

            setSavedContent({
              category,
              tag,
              search,
              public: check.public ? 1 : 0,
              memo,
              title,
              content: contents,
            });
          }}
          cancelEvent={() => setAskEditModal(false)}
        />
      )}

      {isTopAlert && (
        <AlertModal
          title={`상단 고정 게시물이 해당 공지사항으로
        변경됩니다. 계속 하시겠습니까?`}
          btnColor="mint"
          cancelEvent={() => setIsTopAlert(false)}
          confirmEvent={() => {
            if (isAddFaq) {
              setAdd(true);
            } else {
              setAskEditModal(true);
            }
            setIsTopAlert(false);
          }}
        />
      )}
    </FaqDetailFooterContainer>
  );
}

const FaqDetailFooterContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
`;

const Manager = styled.div`
  font-size: 13px;
  line-height: 19.5px;
  text-align: left;
  color: #9a9fa8;
`;
